import {Component, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {VerifypasswordresetComponentModel} from '@login/components/VerifyPasswordReset/model/verifypasswordreset.component.model';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormControlPipe } from '@common_libraries/helpers/pipes/form-control.pipe';


@Component({
    selector: 'app-verify-password-reset',
    templateUrl: './VerifyPasswordReset.component.html',
    providers: [VerifypasswordresetComponentModel],
    standalone: true,
    imports: [FormControlPipe, FormsModule, ReactiveFormsModule, RouterLink]
})

export class VerifyPasswordResetComponent implements OnInit, OnDestroy {

  constructor(private route: ActivatedRoute,
              public model: VerifypasswordresetComponentModel) {  }

  ngOnInit() {
    this.model.initModel(this.route);
  }

  ngOnDestroy() {
    this.model.destroyModel();
  }
}
